import React from 'react'
import OnsaLogo from '../../onsaui/components/OnsaLogo/OnsaLogo'

const SupportPage: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-b from-blue-50 to-white">
      <header className="w-full border-b border-gray-200 bg-white p-4 shadow-sm">
        <div className="mx-auto flex max-w-6xl items-center justify-between">
          <div className="flex items-center space-x-2">
            <OnsaLogo className="h-10 w-auto" />
          </div>
        </div>
      </header>

      <main className="mx-auto flex w-full max-w-6xl flex-1 flex-col px-4 py-10 md:py-16">
        <div className="text-center">
          <h1 className="mb-6 text-3xl font-bold">Support</h1>
          <div className="mb-8 space-y-4">
            <p className="text-lg">
              Need help with <b>Onsa.ai Sales Associate</b>? Our support team is here to help.
            </p>
            <div className="mx-auto max-w-2xl space-y-4 text-left">
              <div className="rounded-lg bg-white p-6 shadow-md">
                <h2 className="mb-4 text-xl font-semibold">Support Hours</h2>
                <p className="text-gray-700">Monday - Friday: 9:00 AM - 6:00 PM Pacific Time</p>
              </div>
              <div className="rounded-lg bg-white p-6 shadow-md">
                <h2 className="mb-4 text-xl font-semibold">Response Time</h2>
                <p className="text-gray-700">We aim to respond to all inquiries within 24 hours during business hours.</p>
              </div>
              <div className="rounded-lg bg-white p-6 shadow-md">
                <h2 className="mb-4 text-xl font-semibold">Contact Us</h2>
                <p className="mb-4 text-gray-700">The best way to reach our support team is via email:</p>
                <a
                  href="mailto:support@onsa.ai"
                  className="inline-block rounded-lg bg-blue-600 px-6 py-3 text-center text-lg font-medium text-white shadow-lg transition-all hover:bg-blue-700"
                >
                  Email Support
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer className="mt-auto border-t border-gray-200 bg-white py-8">
        <div className="mx-auto max-w-6xl px-4">
          <div className="flex flex-col items-center justify-between space-y-4 text-sm text-gray-500 md:flex-row md:space-y-0">
            <div>© {new Date().getFullYear()} Onsa.ai. All rights reserved.</div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default SupportPage
